import Vue from 'vue'

Vue.filter("usd", function (amount) {
  return '$' + Number.parseFloat(amount).toFixed(2)
})

Vue.filter("firstUpper", function (value) {
  return String(value).charAt(0).toUpperCase() + String(value).slice(1);
})
